<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    title="添加测评题说明"
    width="900px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="w-full h-box p-6 box-border">
      <img :src="`${baseUrl}img/eval_illust.png`" class="w-full h-full"/>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'

export default {
  name: 'EvalIllustDialog',
  mixins: [dialogMixins],
}
</script>

<style lang="scss" scoped>
.h-box {
  height: 514px;
}
</style>